import { render, staticRenderFns } from "./UpdateVideoDialog.vue?vue&type=template&id=0df076c2&scoped=true"
import script from "./UpdateVideoDialog.vue?vue&type=script&lang=js"
export * from "./UpdateVideoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df076c2",
  null
  
)

export default component.exports